module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MemGiftbagView.js"));
	}, "MemGiftbagView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MemGiftbagView!./src/pages/Register/MemGiftbag/MemGiftbagView.js
// module id = 814
// module chunks = 438